import React from 'react';
import { Clock } from 'lucide-react';

/** client#13: when the board is searched for a worker, their total scheduled hours for the visible date range. */
const fmtHours = (h) => (Number.isInteger(h) ? `${h}` : `${Math.round(h * 100) / 100}`);

export function StaffHoursSummary({ items, rangeLabel }) {
  if (!items || !items.length) return null;
  return (
    <div className="sticky top-0 z-20 flex flex-wrap items-center gap-2 border-b bg-sky-50/95 px-3 py-1.5 text-xs" data-testid="staff-hours-summary">
      <Clock className="h-3.5 w-3.5 text-sky-700" />
      <span className="text-sky-900 font-medium">Scheduled hours{rangeLabel ? ` · ${rangeLabel}` : ''}:</span>
      {items.map((s) => (
        <span key={s.staff_id} className="inline-flex items-center gap-1 rounded-full border border-sky-200 bg-white px-2 py-0.5" data-testid={`staff-hours-${s.staff_id}`}>
          <span className="font-medium text-slate-800">{s.name}</span>
          <span className="font-mono tabular-nums text-sky-800">{fmtHours(s.hours)} h</span>
          <span className="text-slate-500">· {s.shift_count} shift{s.shift_count === 1 ? '' : 's'}</span>
        </span>
      ))}
    </div>
  );
}
